export enum Right {
    Coordinates = 0,
    Cart,
    Payment,
    AccountExtract,
    Signature
}
